module.exports = __webpack_public_path__ + "img/tr.911db2bb.svg";